// extracted by mini-css-extract-plugin
export default {"gradientBg":"Layout_gradientBg__H7eOD","liquidShape":"Layout_liquidShape__ig6Wn","morphBackground":"Layout_morphBackground__MCs+h","appContainer":"Layout_appContainer__rZgW7"};